<script lang="ts">
  import { X } from 'lucide-svelte';
  import type { Snippet } from 'svelte';

  // Bulk-action bar for a list with multi-select. Pinned to the bottom of the
  // viewport (above the iOS home indicator) so it stays reachable while the
  // list scrolls, rather than sitting inline above a queue you've scrolled
  // past. Renders nothing at all when the selection is empty, so callers can
  // mount it unconditionally.
  const {
    count,
    onClear,
    /** The action buttons. Keep labels short — they pan, they don't wrap. */
    children,
    /** Noun for the count, e.g. "sender" → "3 senders selected". */
    noun = 'item'
  }: {
    count: number;
    onClear: () => void;
    children: Snippet;
    noun?: string;
  } = $props();
</script>

{#if count > 0}
  <div class="tym-selection-bar" role="region" aria-label="Bulk actions">
    <div class="tym-selection-bar-inner">
      <span class="tym-selection-count">
        {count}
        {count === 1 ? noun : `${noun}s`} selected
      </span>
      <div class="tym-selection-actions">
        {@render children()}
      </div>
      <button type="button" class="tym-selection-clear" onclick={onClear} aria-label="Clear selection">
        <X class="h-4 w-4" />
      </button>
    </div>
  </div>
{/if}
